import React from 'react';
import { useTranslation } from 'react-i18next';
import { appNamedRoutes } from 'routes';
import PageSubNav from 'components/nav/PageSubNav';

const LibrarySubNav = () => {
  const { t } = useTranslation();
  const LIBRARY_PAGES = [
    {
      path: appNamedRoutes.cardsLibrary,
      label: t('nav.activityCards'),
    },
    {
      path: appNamedRoutes.programContentLibrary,
      label: t('nav.tips'),
    },
  ];

  return (
    <PageSubNav items={LIBRARY_PAGES} />
  );
};

export default LibrarySubNav;
